import { Container } from "components/layout/Container";
import s from "./SectionAuthorPromo.module.scss";
import { useContext, useRef, useState } from "react";
import classNames from "classnames";
// import { Icon } from "components/UI/Icon";
import { Breadcrumbs } from "components/shared/Breadcrumbs";
import { EditorContent } from "../article/EditorContent";
import { useAuthorSinglePageContext } from "@/helpers/contexts/AuthorSinglePageContext";
import Image from "next/image";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";
import { WrappedIcon } from "@/components/UI/WrappedIcon";
import { Button } from "@/components/UI/Buttons/Button";

export const SectionAuthorPromo = () => {
  const contextData = useAuthorSinglePageContext();
  const [readMoreText, setReadmoreText] = useState("Read more");
  const [isContentOpen, setContentOpen] = useState(false);

  const [totalArticles] = useState(contextData?.pagination?.total || 0);

  const content = useRef<HTMLDivElement>(null);
  const toggleContent = () => {
    if (!content.current) return;
    if (!isContentOpen) {
      content.current.style.maxHeight = content.current.scrollHeight - 20 + "px";
      setReadmoreText("Show less");
    } else {
      content.current.style.maxHeight = "420px";
      setReadmoreText("Read more");
    }
    setContentOpen(!isContentOpen);
  };

  if (!contextData) return null;
  const { author, breadcrumbsList, articles, pagination } = contextData;
  const { fullName, avatar, info, bio, social } = author;
  const articlesPublished = articles.length;
  return (
    <Container>
      <div className={s.section}>
        {breadcrumbsList && <Breadcrumbs color="black" list={breadcrumbsList} className={s.breadcrumbs} />}
        <div className={s.inner}>
          <div className={s.top}>
            <div className={s.photoWrapper}>
              <Image src={avatar.url} alt={avatar.alt} width={140} height={140} />
            </div>
            <h1 className={s.name}>{fullName}</h1>
            <div className={s.age}>{info.age} years</div>

            <div className={s.main}>
              <div className={cn(cs.cardGlassHover, s.card)}>
                <div className={s.infoTitle}>Main info</div>
                <div className={s.infoItem}>
                  <WrappedIcon icon="books" />
                  <div className={s.infoDetails}>
                    <div className={s.infoHeading}>Articles published:</div>
                    <div className={s.infoText}>{totalArticles}</div>
                  </div>
                </div>

                <div className={s.infoItem}>
                  <WrappedIcon icon="sparkles" />
                  <div className={s.infoDetails}>
                    <div className={s.infoHeading}>Experience:</div>
                    <div className={s.infoText}>{info.experience}</div>
                  </div>
                </div>

                <div className={s.infoItem}>
                  <WrappedIcon icon="classical-building" />
                  <div className={s.infoDetails}>
                    <div className={s.infoHeading}>Education:</div>
                    <div className={s.infoText}>{info.education}</div>
                  </div>
                </div>

                <div className={s.infoItem}>
                  <WrappedIcon icon="graduation-cap" />
                  <div className={s.infoDetails}>
                    <div className={s.infoHeading}>Degree:</div>
                    <div className={s.infoText}>{info.degree}</div>
                  </div>
                </div>

                <div className={s.infoItem}>
                  <WrappedIcon icon="briefcase" />
                  <div className={s.infoDetails}>
                    <div className={s.infoHeading}>Position:</div>
                    <div className={s.infoText}>{info.position}</div>
                  </div>
                </div>

                <div className={s.infoItem}>
                  <WrappedIcon icon="pen" />
                  <div className={s.infoDetails}>
                    <div className={s.infoHeading}>Expertise:</div>
                    <div className={s.infoText}>
                      {info.expertise?.split("|")?.map((text, index) => (
                        <Button
                          key={index}
                          type="white"
                          noHover
                          outline
                          size="xs"
                          span
                          className={s.expertise}
                        >
                          {text}
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className={cn(cs.cardGlassHover, s.card)}>
                <div className={s.infoTitle}>Read about author</div>
                {bio && (
                  <div className={s.bio}>
                    <div ref={content} className={s.content}>
                      <EditorContent data={bio} />
                      <div
                        className={classNames(s.readMoreWrapper, isContentOpen && s.readMoreWrapperHide)}
                        onClick={toggleContent}
                      >
                        <div className={s.readMore}>{readMoreText}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
